module.exports = __webpack_public_path__ + "media/fonts/PoppinsLatin-SemiBold-bb84cb246d4427b61697be5aa66933bd.ttf";